/**
 * Full-height loading state. Uses the `.center-loader` class from index.css
 * (ported from the old dashboard). For inline button spinners use Button's
 * `loading` prop instead.
 */
export function Loading({ label = 'Loading…' }: { label?: string }) {
  return <div className="center-loader">{label}</div>;
}
